<template>
  <article class="contacts-group">
    <div class="contacts-group__logo">
      <slot name="logo"/>
    </div>
    <slot/>
  </article>
</template>

<script>
export default {
  name: 'ContactsGroup',
};
</script>

<style scoped lang="scss">
.contacts-group {
  margin-bottom: 0;

  &__logo {
    @include square(80px);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: map-get($margins, small);
    border-radius: 50%;
    background: color(secondary);

    @include mobile {
      @include square(48px);
    }

    svg {
      @include square(60%);
      fill: color(default);
    }
  }
}
</style>
